import React from 'react';
import intl from 'react-intl-universal';
import { withRouter } from 'react-router-dom';
import Lightbox from 'react-simple-lightbox';
import AuthStore from '../stores/AuthStore';

function printBundle(product, parent, group_treshold){
  return (
    <div className="ramka bundleItemList">
      <table>
        <tbody>
          {product.items.map(item => {
            if(item.qty_uom >= group_treshold){
              return (<tr data-barcode={item.barcode || ''} data-qty={item.qty_uom}>
                <td>
                  [{item.default_code || ''}] {item.name}
                  {typeof item.items != 'undefined' && printBundle(item, parent, group_treshold) }
                </td>
                <td className="width1">{item.qty_uom} szt.</td>
                <td className="width1">
                  <div className={`checkbox multiproduct${parent.state.config.productscan?'':' clickable'}`} onClick={parent.checkboxClick}>
                    <div className="checkbox-inner"></div>
                  </div>
                </td>
              </tr>)
            } else {
              let rows = []
              for (let i=0; i<item.qty_uom; i++){
                rows.push(
                  <tr data-barcode={item.barcode || ''} data-qty={item.qty_uom}>
                    <td>
                      [{item.default_code || ''}] {item.name}
                      {typeof item.items != 'undefined' && printBundle(item, parent, group_treshold) }
                    </td>
                    <td className="width1">{item.qty_uom < 1 ? item.qty_uom : 1} szt.</td>
                    <td className="width1">
                      <div className={`checkbox ${parent.state.config.productscan?'':'clickable'}`} onClick={parent.checkboxClick}>
                        <div className="checkbox-inner"></div>
                      </div>
                    </td>
                  </tr>)
              }
              return rows
            }
        })}
        </tbody>
      </table>
    </div>
  )
}

class ProductListItem extends React.Component {
  constructor() {
    super();
    this.state = {
      config: AuthStore.getConfig()
    }
    this.variantClick = this.variantClick.bind(this)
    this.checkboxClick = this.checkboxClick.bind(this)
  }

  variantClick(event) {
    if(event.target.classList.contains('proper')){
      event.target.classList.toggle('selected')
      this.props.parent.toggleConfirmButton()
    }
  }

  checkboxClick(event) {
    if(!this.state.config.productscan || event.currentTarget.classList.contains('service')){
      if(this.props.product.is_pack && event.currentTarget.classList.contains('mainCheckbox')){
        return
      }
      let parent = event.currentTarget.closest('.produkt.ramka')
      let cnt = parent.getAttribute('data-prods')
      if(!event.currentTarget.classList.contains('mainCheckbox')){
        cnt = event.currentTarget.closest('tr').getAttribute('data-qty')
      }
      if(cnt >= (this.state.config.group_treshold || 10) && !event.currentTarget.classList.contains('checked')){
        if(confirm(intl.get('Czy na pewno spakowałeś X pozycji tego SKU?', {cnt: cnt}))){
          event.currentTarget.classList.toggle('checked')
        } else {
          return
        }
      } else {
        event.currentTarget.classList.toggle('checked');
      }
      if(parent.querySelector('.bundleItemList')){
        const alldone = !parent.querySelector('.bundleItemList .checkbox:not(.checked)')
        cnt = parent.getAttribute('data-prods')
        if(alldone && cnt >= (this.state.config.group_treshold || 10)){
          if(confirm(intl.get('Czy na pewno spakowałeś X pozycji tego pakietu?', {cnt: cnt}))){
            parent.querySelector('.product_checkbox .checkbox').classList.toggle('checked', alldone)
          } else {
            event.currentTarget.classList.remove('checked')
            return
          }
        } else {
          parent.querySelector('.product_checkbox .checkbox').classList.toggle('checked', alldone)
        }
      }
      this.props.parent.toggleConfirmButton()
    }
  }

  toggleFold(e) {
    let product = e.currentTarget.parentNode
    if (product.classList.contains('foldable')){
      product.classList.toggle('folded')
    }
  }

  render() {
    const { product, qty, supercount, parent } = this.props
    const odoo = window.ODOO.url + (window.ODOO.port?':'+window.ODOO.port:'')+'/web/product_image?product_id='
    let className = 'ramka produkt'+
                    (supercount?' supercount':'')+
                    (product.red?' red':'')+
                    (product.grey?' grey':'')+
                    (product.is_pack?' has_bundle':'')
    let service = product.product_type == 'service'
    const listMode = this.state.config.product_list_view === 'list'
    let title = (product.default_code ? '['+product.default_code+'] ' : '') + product.product_name
    return (
      <div className={className} data-prods={qty} data-barcode={product.barcode || ''}>
        {!listMode &&
          <h4 onClick={this.toggleFold}>{title}</h4>
        }
        <div>
          <Lightbox key={product.line_id}>
            <img src={odoo+product.product_id}/>
          </Lightbox>
          <div className="product_details">
            {listMode &&
              <h4>{title}</h4>
            }
            <div>
              <label>{intl.get('Ilość')}:</label>
              <span>{qty}</span>
            </div>
            <div>
              <label>{intl.get('Cena jednostkowa')}:</label>
              <span>{product.price_unit}</span>
            </div>
            {this.state.config.stock_location &&
              <div>
                <label>{intl.get('Strefa składowania')}:</label>
                <span>{product.location}</span>
              </div>
            }
            {this.state.config.variantcheck && product.all_attributes && Object.keys(product.all_attributes).length > 0 &&
              <div className="productVariants">
                {Object.keys(product.all_attributes).map((attr, i) => {
                  let values = product.all_attributes[attr]
                  if(values.length > 1){
                    return (<div key={i}>
                      <label>{attr}: </label>
                      {(values.map((value, j) => {
                          return (<div key={j} className={'productVariantValue'+(value==product.searched_attributes[attr]?' proper':'')} onClick={this.variantClick}>{value}</div>)
                      }))}
                    </div>)
                  }
                })}
              </div>
            }
          </div>
          { product.is_pack && listMode &&
            <div className="bundleWrapper listView">
              {printBundle(product, this, (this.state.config.group_treshold || 10))}
            </div>
          }
          {(!service || (this.state.config.enable_kw && parent.state.multi_delivery)) &&
            <div className={`product_checkbox ${this.state.config.productscan?'':'clickable'}`}>
              <div className={`checkbox mainCheckbox ${service?'service':''}`} data-line={product.line_id} onClick={this.checkboxClick}>
                <div className="checkbox-inner"></div>
              </div>
            </div>
          }
        </div>
        { product.is_pack && !listMode &&
          <div className="bundleWrapper">
            {printBundle(product, this, (this.state.config.group_treshold || 10))}
          </div>
        }
      </div>
    );
  }
}

export default withRouter(ProductListItem);



// WEBPACK FOOTER //
// ./src/components/ProductListItem.js